import { store } from '../../store/index';
import {getCall, postCall} from "./http.service";
import {ALL_COUNTRIES, CITIES_IN_REGION, REGIONS_ONLY, REGION_DETAILS, CITY_DETAILS} from "../config/endpoints/location";
import {ALL_USERS} from "../config/endpoints/location";
import {SEARCH_USERS} from "../config/endpoints/location";
import {SEARCH_PROJECTS} from "../config/endpoints/location";

async function loadCountries() {
  await getCall(ALL_COUNTRIES)
      .then((response) => {
        store.commit('storeCountries', response.data.data);
      })
      .catch(() => {
      })
      .finally(() => {

      });
}
async function searchProjects(params, page) {
    let url = SEARCH_PROJECTS + '?page=' + page;
    return await postCall(url, params);

}

async function getCountries() {
    if(store.getters.countries.length < 1) {
        await loadCountries();
        return store.getters.countries;
    } else {
        return store.getters.countries;
    }

}
async function loadRegions() {
    await getCall(REGIONS_ONLY)
        .then((response) => {
            store.commit('storeRegions', response.data.data);
        })
        .catch(() => {
        })
        .finally(() => {

        });
}

async function getCities(region_id) {
    return await getCall(CITIES_IN_REGION + region_id);
}

async function getRegions() {
    if(store.getters.regions.length < 1) {
        await loadRegions();
        return store.getters.regions;
    } else {
        return store.getters.regions;
    }

}

async function getRegion(id) {
    return await getCall(REGION_DETAILS + id);

}

async function getCity(id) {
    return await getCall(CITY_DETAILS + id);
}

async function getCountry(id) {
    let countries = await getCountries();
    let countryId = parseInt(id);
    for (let i = 0; i < countries.length; i++) {
        if((countries[i].id === countryId)) {
            return countries[i];
        }
    }
    return '';
}

async function getRegionsForCountries(countryId) {
    let countries = await getCountries();
    for (let i = 0; i < countries.length; i++) {
        if((countries[i].id === countryId)) {
            return countries[i];
        }
    }
}
async function getUsersForCountries() {
    return await getCall(ALL_USERS);
}
async function searchUsers(params, page) {
    let url = SEARCH_USERS + '?page=' + page;
    return await postCall(url, params);
}

async function searchCountries(str) {
  let countries = await getCountries();
  let matchedCountries = [];
  countries.forEach((country) => {
    if((country.name.toLowerCase().search(str.toLowerCase())) !== -1) {
      matchedCountries.push(country)
    }
  });

  return matchedCountries;
}

export { getCountries, getCountry, getRegions, searchCountries, getRegionsForCountries, getUsersForCountries, searchUsers, searchProjects, getCities, getRegion, getCity };
